
import {Modal} from "react-bootstrap";
import {useIntl} from "react-intl";
import React, {useCallback, useEffect, useRef, useState} from "react";
import './modals.scss';
import '../../Steps/RequestInfo/request-info.scss';
import {AdminService, AuthService, WLOCreditAPIService} from "../../../services";
import {Check} from "@mui/icons-material";
import {AppRoutes} from "../../../Router";
import {useNavigate} from "react-router-dom";
import { useSignContext } from "../../../hooks/useSignContext";
import { useRequestContext } from "../../../hooks/useRequestContext";
import Moment from 'moment';
import { WloCreditoService } from "../../../types";
interface EnterCodeProps {
    token: string;
    show: boolean;
    onHide: () => void;
    sendCode: () => void;
    errors?: any;
    values?: any;
}

export function EnterCode(props: EnterCodeProps) {
    const {sign, setSign} = useSignContext();
    const {request, setRequest} = useRequestContext();
    const navigate = useNavigate();
    const {onHide, show, token, sendCode} = props;
    const [counter, setCounter] = useState(300);
    const timeOutCallback = useCallback(() => setCounter(currTimer => currTimer - 1), []);
    useEffect(() => {
        if(show){
            counter > 0 && setTimeout(timeOutCallback, 1000);
        }
      }, [counter, timeOutCallback,show]);
    const intl = useIntl();
    const defaultCode = new Array(6).fill('');
    const [modalShow, setModalShow] = React.useState(false);
    const [isSucessful, setIsSucessful] = React.useState(false);
    const [isVerifying, setIsVerifying] = React.useState(false);
    const [errorCode, setErrorCode] = useState<boolean>(false);
    const [viewNewCode, setViewNewCode] = useState<boolean>(false);
    const [code, setCode] = useState<string[]>(defaultCode);
    const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
    const [codigoClie, setCodigo] = useState("");
    const resetCode = () => {
        setCounter(300)
        setCode(defaultCode);
        onHide()
    }

    const handleSearchSagrilaft = async () => {
        onHide();
    }
    const verifyGas= async ()=> {
        let presentaRiesgos=false
        let puntaje=0
        let scorepuntaje=0
        let ingresoValidado=false
        let enestudio=true
        let negado=false
        let valorDataCreditoCodeudor=false
        const tipodeudor = Number(request?.valoresLogin?.tipodeudor ?? 1);

        try {
            const estadoTerce = await AdminService.entidadTer("");
            let consulta: any;

            // Tras OTP: siempre consulta/grabar Cygnus (antes dependían del flag Datos_Referencias[1])
            try {
                let sends:WloCreditoService.SolicitudDetalla={
                    Pws_Num_Solicitud:request.numSol!,
                    Pws_Identificacion:sign.numIdentification!,
                    // Cacmpu: usar el tipo de identificación directo (no catálogo Colombia s_datacredito)
                    Pws_Tip_Identificacion: String(sign.typeIdentification ?? ''),
                    Pws_Perfil_Acceso:"",
                    Pws_Fec_Solicitud:"",
                }
                consulta = await WLOCreditAPIService.consultaSolicitudCygnusDetal(sends)
            } catch (e) {
                console.error('verifyGas consulta detalle', e);
            }

            const resultConsultaPersona = await WLOCreditAPIService.consultaSolicitudCygnus({
                Pws_Identificacion: sign.numIdentification,
                Pws_Tip_Identificacion: sign.typeIdentification!,
            }).catch((e: any) => {
                console.error('verifyGas consulta persona', e);
                return null;
            });

            try {
                let ingresos = resultConsultaPersona?.payload?.data?.datos_operfinan?.Datos_operfinan?.[0];
                if (ingresos) {
                const operFinancieras = {
                    s_num_solicitud: request.numSol!,
                    s_identificacion: sign.numIdentification!,
                    s_tipo_identificacion: sign.typeIdentification,
                    s_ingreso_principal: ingresos.Pws_Ingreso_Principal,
                    s_otros_ingresos: ingresos.Pws_otros_ingresos,
                    s_otros_egresos: ingresos.Pws_Otros_egresos,
                    s_arriendo: ingresos.Pws_Arriendo,
                    s_concep_otr_ingre: ingresos.Pws_Concep_otr_ingre,
                    s_declarante_ren: ingresos.Pws_Declarante_ren,
                    s_moneda_ext: ingresos.Pws_Moneda_ext,
                    s_monext_oper: ingresos.Pws_Monext_oper,
                    s_tip_monext: ingresos.Pws_Tip_monext,
                    s_cuent_ext: ingresos.Pws_Cuent_ext,
                    s_cuen_extban: ingresos.Pws_Cuen_extban,
                    s_cuen_extnum: ingresos.Pws_Cuen_extnum,
                    s_cuen_extpais: ingresos.Pws_Cuen_extpais,
                    s_cuen_extciudad: ingresos.Pws_Cuen_extciudad,
                };
                await WLOCreditAPIService.addFinancialInformation(operFinancieras);
                const tipPerfilCygnus =
                    resultConsultaPersona.payload.data.datos_persona?.Datos_persona?.[0]?.Pws_Tip_Perfil ??
                    request.personCygnus?.Pws_Tip_Perfil ??
                    '2';
                await WLOCreditAPIService.grabar_cignus({
                    Pws_Identificacion: sign.numIdentification!,
                    Pws_Tip_Identificacion: String(sign.typeIdentification!),
                    Pws_Tip_Perfil: String(tipPerfilCygnus || '2'),
                });
                }
            } catch (e) {}

            //Listas restrictivas API
            if (sign.typeIdentification==="1"){
                const personaDatos = consulta?.payload?.data?.datos_persona?.Datos_persona?.[0];
                if (personaDatos) {
                const listasR={
                people: [
                            {
                            name: (personaDatos.Pws_Nombres +" " +personaDatos.Pws_Apellidos1 + " " +personaDatos.Pws_Apellidos2 ),
                            doc_id: sign.numIdentification!,
                            tipo_doc: "CC"
                            }
                    ]
                };
            try {
                const listas = await WLOCreditAPIService.getListasRestrictivas(listasR);
                const documentRequest= {
                    Pws_num_solicitud: request.numSol!,
                    Pws_Identificacion: sign.numIdentification!,
                    Pws_Tip_Identificacion: sign.typeIdentification!,
                    Pws_Doc_Tipo: "5",
                    Pws_Doc_nombre: 'Listas restrictivas.pdf',
                    Pws_Doc_estado: "1",
                    Pws_Doc_ruta: "1",
                    Pws_Clave_doc: listas.payload,
                };
                await WLOCreditAPIService.addDocuments(documentRequest);
            } catch (error) {
                console.log("E-LR");
            }
                }
            }

            // Score Cygnus: siempre tras OTP (no depende del flag de entidad tercero)
            if(tipodeudor < 2){
                try {
                    const response10 = await WLOCreditAPIService.EvaluaScore({
                        ps_radicado: String(request.valoresLogin?.radicado || request.numSol || ''),
                        ps_identificacion: String(sign.numIdentification),
                        ps_cod_lin: String(request.valoresLogin?.lineacredito || ''),
                        ps_tipoCliente: request.valoresLogin?.tipocliente == "" || !request.valoresLogin?.tipocliente
                            ? "2"
                            : request.valoresLogin.tipocliente,
                        ps_tip_deucode: String(request.valoresLogin?.tipodeudor ?? tipodeudor),
                    });
                    scorepuntaje = response10?.payload?.data?.puntaje_obtenido ?? 0;
                } catch (e) {
                    console.error('verifyGas EvaluaScore', e);
                    scorepuntaje = 0;
                }

                let estadocygnus = scorepuntaje >= 51 ? "0" : "1";
                const data6 = {
                    Pws_num_solicitud : request.numSol!,
                    Pws_Identificacion : sign.numIdentification!,
                    Pws_Tip_Identificacion: sign.typeIdentification!,
                    Pws_Fec_gen:  Moment(new Date()).format('MM/DD/YYYY'),
                    Pws_estado_resotp: estadocygnus,
                    Pws_Tip_val: '4',
                    Pws_Puntaje: String(scorepuntaje),
                    Pws_Entidad_Consul: '5',
                    Pws_Num_cuodat: '',
                    Pws_Xml_Dc: '',
                };
                const guardarScore =
                    !estadoTerce?.payload ||
                    estadoTerce.payload.data?.ListRef?.Datos_Referencias?.[4]?.s_descripcion_legal == "1";
                if (guardarScore) {
                    try {
                        await WLOCreditAPIService.regDataCreditoAndSagrilaft(data6);
                    } catch (e) {
                        console.error('verifyGas reg score', e);
                    }
                }
            } else {
                scorepuntaje = 0;
            }

            if(tipodeudor < 2){
                try {
                const solicitudResulado = await WLOCreditAPIService.addSolicitud({
                    Pws_num_solicitud:request.numSol!,
                    Pws_Identificacion:sign.numIdentification!,
                    Pws_Tip_Identificacion: sign.typeIdentification!
                });
               
                presentaRiesgos = false;
                valorDataCreditoCodeudor = false;
                negado = false;
                enestudio = true;
                const datosSol = solicitudResulado?.payload?.data?.Datos_Sol?.Datos_Sol?.[0];
                if (datosSol) {
                datosSol.Pws_Tip_Estado = "12";
                if (datosSol.Pws_Estado != null) {
                    datosSol.Pws_Estado = "S";
                }
                if (datosSol.pws_estado_solicitud != null) {
                    datosSol.pws_estado_solicitud = "S";
                }
                if (datosSol.pws_estado_credito != null) {
                    datosSol.pws_estado_credito = "S";
                }
                await WLOCreditAPIService.addSolicitud(datosSol)
                }

            const datasEstudio={
                id:"hola",
                number:request.numSol!,
                email:sign.email!,
                typeIdent:sign.typeIdentification!,
                numbIdent:sign.numIdentification!,
                Negado:negado,
              }
              try {
                await WLOCreditAPIService.getEmail(datasEstudio);
              } catch (e) {
                console.error('verifyGas email estudio', e);
              }
                } catch (e) {
                    console.error('verifyGas actualización solicitud', e);
                }
            }
        } catch (e) {
            console.error('verifyGas error general', e);
            enestudio = true;
        } finally {
         navigate(AppRoutes.VIEW_DOCUMENT_SIGN+"?"+(presentaRiesgos?"1":"0")+"-"+(negado?"1":"0")+"-"+(valorDataCreditoCodeudor?"1":"0")+"-"+(enestudio?"1":"0"), {replace: true});
        }
    }
    //guarda el cupo
    // const envioCupo= async()=>{
    //     let lineas;
    //     const valor= await AdminService.getlineascredito();
    //     lineas = valor.payload.data.ListLineaCredito.Datos_LineasCredito.length;
    //     let nume = 0
    //     let cupoRot;
    //     let codigo= 0;
    //     let result;
    //     let fecha_inicia
        
    //     let valoragregado={
    //       Pws_num_solicitud: request.numSol!,
    //       Pws_fec_solicitud_ini:"",
    //       Pws_fec_solicitud_fin:"",
    //       Pws_Tip_estado: "",
    //       Pws_Tip_Consulta: "1"
    //     }

    //     const consultaSolicitud = await WLOCreditAPIService.consultaSolicitudListadoCygnus(valoragregado)
    //     //.then((data) => {
    //     //  fecha_inicia = data.payload.data.datos_soli.datos_Sol[0].Pws_fec_solicitud;
    //     //  result = data.payload.data.datos_soli.datos_Sol[0].Pws_Lincre
    //     //});


        // while (nume < lineas){
        //     if(valor.payload.data.ListLineaCredito.Datos_LineasCredito[nume].s_nombre == result){
        //       cupoRot = valor.payload.data.ListLineaCredito.Datos_LineasCredito[nume].s_rotativo
        //       codigo = valor.payload.data.ListLineaCredito.Datos_LineasCredito[nume].s_codigo
        //       setCodigo(valor.payload.data.ListLineaCredito.Datos_LineasCredito[nume].s_codigo)
        //     }
        //   nume+=1
        // }
    //     const cupo = String(localStorage.getItem('cupoRotativo'))
    //     var d = new Date,
    //       dformat = [d.getMonth()+1,
    //                 d.getDate(),
    //                 d.getFullYear()].join('/');
    //     const creaCupo={
    //       s_r_ident_cliente: String(sign.numIdentification),
    //       s_r_lin_cred: String(codigo),
    //       s_r_fec_ini_cupo: String(dformat),
    //       s_r_fec_fin_cupo: String(dformat),
    //       s_r_monto_cupo: String(cupo)
    //     }
    //     const responde  = await WLOCreditAPIService.registraCupo(creaCupo)
    // }

    const setCodeValue = (event: any, position: number) => {
        const {target} = event;
        const value = target.value.trim();
        if (isNaN(value) || value.length > 1) return;
        if (errorCode) setErrorCode(false);
        const newCode = JSON.parse(JSON.stringify(code));
        newCode[position] = value;
        setCode(newCode);
        if (value && inputRefs.current[position + 1]) {
            inputRefs.current[position + 1]?.focus();
        }
    }

    const clickVerifyCode = async () => {
        if (isVerifying) return;
        try {
            const codeStringValue = code.join('');
            if (codeStringValue.length < 6) return;
            setIsVerifying(true);
            setErrorCode(false);
            const data = {
                codes: codeStringValue,
                token,
                identificacion: sign.numIdentification,
                tipoIdentificacion: sign.typeIdentification
            };
            const response = await WLOCreditAPIService.verifyCodeRegOtp(data);
            const hasErrors = response?.errors && (response.errors === true || response.errors?.invalidCode || response.errors?.invalidToken);
            if (hasErrors) {
                setSign({...sign, signValidated: false});
                setErrorCode(true);
                setIsVerifying(false);
                return;
            }
            setErrorCode(false);
            setIsSucessful(true);
            setSign({
                ...sign,
                signValidated: true,
                otp: codeStringValue,
            });
            // Guardar PDF firmado en segundo plano; no bloquea si el WS falla o tarda
            void persistSignedAuthorizationDocument(codeStringValue)
                .then((signedPdf) => {
                    if (signedPdf) {
                        setSign({
                            ...sign,
                            signValidated: true,
                            otp: codeStringValue,
                            signedDocumentDataUrl: signedPdf,
                        });
                    }
                })
                .catch((err) => {
                    console.error('Error guardando documento firmado:', err);
                });
            await verifyGas();
        } catch (error: any) {
            const { errors } = error;
            setSign({...sign, signValidated: false});
            setErrorCode(true);
            setIsVerifying(false);
        }
    }

    const sendNewCode = () => {
        sendCode();
        setErrorCode(false);
        setViewNewCode(true);
        setCounter(300)
    }

    const viewInputEnterCode = () => {
        setCode(defaultCode);
        setViewNewCode(false);
    }
    const handleKeyUp = (event:any, index:number) => {
        if (event.key === "Backspace" && !code[index] && inputRefs.current[index - 1]) {
            inputRefs.current[index - 1]?.focus();
        }
    }

    /** Mismo flujo que carga de documentos del cliente: PDF firmado (data URL) vía `addDocuments`. */
    const persistSignedAuthorizationDocument = async (otpCode: string): Promise<string | null> => {
        const docNumSol = request.numSol;
        const docIdent = request.personCygnus?.Pws_Identificacion ?? sign.numIdentification;
        const docTipoRaw = request.personCygnus?.Pws_Tip_Identificacion ?? sign.typeIdentification;
        const docTipoIdent = docTipoRaw != null ? String(docTipoRaw) : '';
        if (!docNumSol || !docIdent || !docTipoIdent) return null;
        const valor = await WLOCreditAPIService.getDocumento({
            Pws_num_solicitud: docNumSol,
            Pws_Identificacion: docIdent,
            Pws_Tip_Identificacion: docTipoIdent,
            otp: otpCode,
        });
        const payload = valor?.payload;
        if (!payload || typeof payload !== 'string') return null;
        const documentRequest: WloCreditoService.DocumentosRequest = {
            Pws_num_solicitud: docNumSol,
            Pws_Identificacion: docIdent,
            Pws_Tip_Identificacion: docTipoIdent,
            Pws_Doc_Tipo: "12",
            Pws_Doc_nombre: "Documento_Firmado.pdf",
            Pws_Doc_estado: "1",
            Pws_Doc_ruta: "1",
            Pws_Clave_doc: payload,
        };
        await WLOCreditAPIService.addDocuments(documentRequest);
        return payload;
    };
    const renderInputEnterCode = () => {
        return (
            <>
            <div>
                <h3 className="sub-title">
                    <p>Al ingresar el código, aceptas ser consultado en listas restrictivas y sagrilaft.</p>
                    <p>Por favor inserta aquí:</p>
                </h3>
                <div className="flex-container-modals p-0 m-0">
                    {code.map((value: string, index: number) => {
                        return <div key={index}>
                            <input
                                   ref={(el) => (inputRefs.current[index] = el)}
                                   value={value}
                                   className={"input-code-general"}
                                   type="text"
                                   inputMode="numeric"
                                   maxLength={1}
                                   disabled={isVerifying || isSucessful}
                                   onChange={event => setCodeValue(event, index)}  
                                   onKeyUp={event =>handleKeyUp(event, index)}/>
                        </div>
                    })}
                </div>
                <h3 className="sub-title">
                    <p>Falta {counter} seg para poder envia de nuevo el codigo</p>
                </h3>
                <br/>
                {counter>0?<>
                    <div className="button-center">
                    <div
                        className={`form-know-you-item-button button-red color-red${isVerifying ? ' submitDisable' : ''}`}
                        style={isVerifying ? { opacity: 0.7, pointerEvents: 'none', cursor: 'not-allowed' } : undefined}
                        aria-busy={isVerifying}
                        onClick={clickVerifyCode}>
                        {isVerifying ? 'Validando...' : 'Continuar'}
                    </div>
                </div>
                </>:<>
                <div className="button-center">
                    <div className="form-know-you-item-button button-red color-red"
                         onClick={sendNewCode}>Pedir Codigo
                    </div>
                </div>
                </>}
               
            </div>
            </>
            
        )
    }

    const renderErrorCodeBanner = () => {
        return (
            <div className="mb-3">
                <h3 className="sub-title color-red">Has ingresado un código incorrecto o tu tiempo para ingresarlo ha caducado.</h3>
                <br/>
            </div>
        )
    }

    const renderNewCode = () => {
        return (
            <div>
                <h3 className="sub-title color-green">Se ha enviado un nuevó código revisa tu correo o celular
                    registrado</h3>
                <br/>
                <div className="button-center">
                    <div className="form-know-you-item-button button-green color-green"
                         onClick={viewInputEnterCode}>Aceptar
                    </div>
                </div>
            </div>
        )
    }

    const renderFirmaCorrecta = () => {
        return (
            <div>
                <div className="row">
                    <Check/>
                </div>
                <br/>
                <h3 className="sub-title color-green">Has firmado correctamente para la autorización de los datos.
                    Espera un momento...</h3>
                <br/>
                <h1 className="sub-title color-green" style={{ textAlign:'center'}}  >NO CERRAR</h1>
                {/* <div className="button-center">
                    <div className="form-know-you-item-button button-red color-red"
                         >Aceptar
                    </div>
                </div> */}
            </div>
        )
    }

    const renderTemplate = () => {
        if (viewNewCode) return renderNewCode();
        if (isSucessful) return renderFirmaCorrecta();
        return (
            <>
                {errorCode && renderErrorCodeBanner()}
                {renderInputEnterCode()}
            </>
        );
    }

    return (
            <Modal
                        className="modal-otp"
                        {...props}
                        onHide={resetCode}
                        size="xl"
                        aria-labelledby="contained-modal-title-center"
                        centered
                        backdrop="static"
                    >
                        <Modal.Header >
                        </Modal.Header>
                        <Modal.Body>
                            {renderTemplate()}
                        </Modal.Body>
                    </Modal>
    )
}